<template>
  <div :id="`accordion-services-${codigo}${ordem}`" class="collapse card-body" aria-labelledby="headingServices" :data-parent="`#accordion-services-${codigo}${ordem}`">
    <div id="headingOne" style="border-radius: var(--mdb-card-inner-border-radius) var(--mdb-card-inner-border-radius) 0 0;min-height: 72px !important;">
      <div class="custom-header p-3" id="headingOne">
        <h5 class="mb-0">
          <button class="btn btn-link collapsed home-button" aria-expanded="false" @click="zerarAtributoPercorrido()">
            <i class="fa fa-home custom-icon-home" aria-hidden="false"></i>
          </button>
          <button v-if="listaAtributoPercorrido.length >= 1" style="" v-for="atributoPercorido in listaAtributoPercorrido" class="btn btn-link collapsed menu-button" aria-expanded="false" @click="atualizarHierarquia('', true, atributoPercorido.ordem), alterarAtributoPercorrido(atributoPercorido.ordem)">
            <i class="fa fa-angle-right custom-icon-right" aria-hidden="false"></i>
            <span>{{atributoPercorido.nome}}</span>
          </button>
        </h5>
      </div>

      <div class="mt-4 mb-4" v-if="servicoAtributos.entrada === entrada && statusAtributoPrincipal === true" v-for="(servicoAtributos, index) in atributosFiltrados" model="selectedListasServicosAtributos">
        <div v-if="index > 0">
          <hr>
        </div>
        <h5 class="custom-column">
          <div v-if="servicoAtributos.tipo === 'O'">
            <div @click="confirmacaoExclusaoAtributo(codigo, servicoAtributos.ordem, servicoAtributos.nome)" class="icon-content-trash mt-2">
              <i class="fa-solid fa-trash custom-icon"></i>
            </div>
            <div @click="openModalEditarParametros(entrada, codigo, servicoAtributos)"  class="icon-content-trash mt-2">
              <i class="fa-solid fa-pen custom-icon"></i>
            </div>
            <div v-if="clone" @click="openModalAddParametros(entrada, codigo, servicoAtributos.ordem)" class="icon-content mt-2">
              <i  class="fa-solid fa-add plus-icon custom-icon"></i>
            </div>
          </div>
          <div v-if="servicoAtributos.tipo != 'O'">
            <div @click="confirmacaoExclusaoAtributo(codigo, servicoAtributos.ordem, servicoAtributos.nome)" class="icon-content-trash mt-2">
              <i class="fa-solid fa-trash custom-icon"></i>
            </div>

            <div @click="openModalEditarParametros(entrada, codigo, servicoAtributos)" class="icon-content-trash mt-2">
              <i class="fa-solid fa-pen custom-icon"></i>
            </div>
          </div>

          <button :id="`${servicoAtributos.ordem}`" v-if="servicoAtributos.tipo === 'O'" class="btn btn-link collapsed" style="display: flex; align-items: center; padding-top: 5px !important;padding-bottom: 5px !important; "  data-toggle="collapse" aria-expanded="false" @click="alterarIcone('atributoPrincipal', 'atributes', `${servicoAtributos.ordem}`), atualizarHierarquia(servicoAtributos.hierarquia, false, `${servicoAtributos.ordem}`), atualizarAtributoPercorrido(servicoAtributos.ordem, servicoAtributos.nome, servicoAtributos.hierarquia)" :data-target="`#accordion-services-${parseInt(codigo.match(/\d+/)[0])}-${servicoAtributos.nome}3-hierarquia`">
            <span class="custom-atribute-span"> {{servicoAtributos.nome}} </span>
          </button>
          <button :id="`${servicoAtributos.ordem}`" v-if="servicoAtributos.tipo != 'O'" disabled class="btn btn-link collapsed" style="display: flex; align-items: center; padding-top: 5px !important;padding-bottom: 5px !important;"  data-toggle="collapse" aria-expanded="false" @click="alterarIcone('atributoPrincipal', 'atributes', `${servicoAtributos.ordem}`), atualizarHierarquia(servicoAtributos.hierarquia, false, `${servicoAtributos.ordem}`), atualizarAtributoPercorrido(servicoAtributos.ordem, servicoAtributos.nome, servicoAtributos.hierarquia)" :data-target="`#accordion-services-${parseInt(codigo.match(/\d+/)[0])}-${servicoAtributos.nome}3-hierarquia`">
            <span class="custom-atribute-span"> {{servicoAtributos.nome}} </span>
          </button>
        </h5>
      </div>

      <div class="mt-4 mb-4" v-if="servicoAtributos.entrada === entrada && statusAtributoSecundario === true" v-for="(servicoAtributos, index) in listaSecundariaAtributosHierarquia" model="selectedListasServicosAtributos">   
        <div v-if="index > 0">
          <hr>
        </div>
        <h5 class="custom-column">
          <div v-if="servicoAtributos.tipo === 'O'">
            <div @click="confirmacaoExclusaoAtributo(codigo, servicoAtributos.ordem, servicoAtributos.nome)" class="icon-content-trash mt-2">
              <i class="fa-solid fa-trash custom-icon"></i>
            </div>
            <div @click="openModalEditarParametros(entrada, codigo, servicoAtributos)"  class="icon-content-trash mt-2">
              <i class="fa-solid fa-pen custom-icon"></i>
            </div>
            <div v-if="clone" @click="openModalAddParametros(entrada, codigo, servicoAtributos.ordem)" class="icon-content mt-2">
              <i class="fa-solid fa-add plus-icon custom-icon"></i>
            </div>
          </div>
          <div v-if="servicoAtributos.tipo != 'O'">
            <div @click="confirmacaoExclusaoAtributo(codigo, servicoAtributos.ordem, servicoAtributos.nome)" class="icon-content-trash mt-2">
              <i class="fa-solid fa-trash custom-icon"></i>
            </div>
            
            <div @click="openModalEditarParametros(entrada, codigo, servicoAtributos)" class="icon-content-trash mt-2">
              <i class="fa-solid fa-pen custom-icon"></i>
            </div>
          </div>

          <button :id="`${servicoAtributos.ordem}`" v-if="servicoAtributos.tipo === 'O'" class="btn btn-link collapsed" style="display: flex; align-items: center;padding-top: 5px !important;padding-bottom: 5px !important;"  data-toggle="collapse" aria-expanded="false" @click="atualizarHierarquia(servicoAtributos.hierarquia, false, `${servicoAtributos.ordem}`), alterarIcone('', 'atributes', `${servicoAtributos.ordem}`), atualizarAtributoPercorrido(servicoAtributos.ordem, servicoAtributos.nome, servicoAtributos.hierarquia)">
            <span class="custom-atribute-span"> {{servicoAtributos.nome}} </span>
          </button>
          <button :id="`${servicoAtributos.ordem}`" v-if="servicoAtributos.tipo != 'O'" disabled class="btn btn-link collapsed" style="display: flex; align-items: center;padding-top: 5px !important;padding-bottom: 5px !important;"  data-toggle="collapse" aria-expanded="false" @click="atualizarHierarquia(servicoAtributos.hierarquia, false, `${servicoAtributos.ordem} `), alterarIcone('', 'atributes', `${servicoAtributos.ordem}`), atualizarAtributoPercorrido(servicoAtributos.ordem, servicoAtributos.nome, servicoAtributos.hierarquia)">
            <span class="custom-atribute-span"> {{servicoAtributos.nome}} </span>
          </button>
        </h5>
      </div>

    </div>

    <!-- O Modal Editar Parametros -->
    <div v-if="showModalEditParametros" class="modal modal-edit-parametros fade" id="myModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" style="font-weight: 600;">Editar Parâmetros</h5>
            <button type="button" class="btn-close" data-mdb-dismiss="modal" @click="closeModal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <div class="row">
              <div class="col-md-6">
                <div class="form-outline">
                  <label for="tipoAutenticacao" class="green-label">Campo:</label>
                  <select v-if="clone" class="form-select select-modal modal-input" v-model="this.requestType" id="tipoAutenticacao" :disabled="this.bloqueioCampo">
                    <option value="Selecione" selected>Selecione</option>
                    <option value="E">Entrada</option>
                    <option value="H">Header</option>
                    <option value="G">Get</option>
                    <option value="F">Form</option>
                    <option value="S">Saída</option>
                    <option value="W">Alerta</option>
                    <option value="U">Erro</option>
                    <option value="B">Body</option>
                  </select>
                  <select v-if="this.clone !== true" class="form-select select-modal modal-input" v-model="this.requestType" id="tipoAutenticacao" :disabled="this.bloqueioCampo">
                    <option value="Selecione" selected>Selecione</option>
                    <option value="E">Entrada</option>
                    <option value="H">Header</option>
                    <option value="G">Get</option>
                    <option value="F">Form</option>
                    <option value="S">Saída</option>
                    <option value="W">Alerta</option>
                    <option value="U">Erro</option>
                    <option value="B">Body</option>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-outline">
                  <label for="tipoAutenticacaoSelect" class="green-label">Tipo:</label>
                  <select class="form-select select-modal modal-input" @change="validarTipo('tipoAutenticacaoSelect','modify')" v-model="tempTipo" id="tipoAutenticacaoSelect" :disabled="this.bloqueioTipo">
                    <option value="Selecione" selected>Selecione</option>
                    <option value="O">Objeto</option>
                    <option value="C">Campo</option>
                    <option value="A">Autenticação</option>
                  </select>
                </div>
              </div>
            </div>
            
            <!-- Nome row -->
            <div class="row">
              <div class="col-md-6">
                <div class="form-outline">
                  <label class="green-label" for="textareaId">Nome:</label>
                  <input :disabled="this.bloqueioNome" class="input-modal modal-input" v-model="tempNome" style="width:86% !important">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-outline">
                  <label for="formatoEditar" class="green-label">Formato:</label>
                  <select class="form-select select-modal modal-input" id="formatoEditar" :disabled="this.bloqueioFormato">
                    <option value="Selecione" selected>Selecione</option>
                    <option value="A">Alfanumérico</option>
                    <option value="N">Numérico</option>
                    <option value="V">Valor</option>
                    <option value="O">Objeto - Container/classe</option>
                  </select>
                </div>
              </div>
              
            </div>
    
            <!-- Obrigatório, Formato, and Lista row -->
            <div class="row">
              <div class="col-md-6">
                <div class="form-outline">
                  <label for="tipoAutenticacao" class="green-label">Obrigatório:</label>
                  <select class="form-select select-modal modal-input" v-model="atributo.obrigatorio" id="tipoAutenticacao">
                    <option value="Selecione" selected>Selecione</option>
                    <option value="S">Sim</option>
                    <option value="N">Não</option>
                  </select>
                </div>
              </div>
              
              <div class="col-md-6">
                <div class="form-outline">
                  <label for="tipoAutenticacao" class="green-label">Lista:</label>
                  <select class="form-select select-modal modal-input" v-model="atributo.lista" id="tipoAutenticacao" :disabled="this.bloqueioLista">
                    <option value="Selecione" selected>Selecione</option>
                    <option value="S">Sim</option>
                    <option value="N">Não</option>
                  </select>
                </div>
              </div>
            </div>
  
            <div class="mt-1 col-12">
              <!-- Nav Tabs com MDB Modal -->
              <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item col-4" role="presentation">
                  <a class="nav-link active" id="descricao-tab" data-mdb-toggle="tab" href="#descricao" role="tab" aria-controls="descricao" aria-selected="true">Descrição</a>
                </li>
                <li class="nav-item col-4" role="presentation">
                  <a class="nav-link" id="dominio-tab" data-mdb-toggle="tab" href="#dominio" role="tab" aria-controls="dominio" aria-selected="false">Domínio</a>
                </li>
                <li class="nav-item col-4" role="presentation">
                  <a class="nav-link" id="observacao-tab" data-mdb-toggle="tab" href="#observacao" role="tab" aria-controls="observacao" aria-selected="false">Observação</a>
                </li>
              </ul>
  
              <!-- Tab content -->
              <div class="tab-content mt-5 mb-5" id="myTabContent">
                <!-- Aba Descrição (aberta por padrão) -->
                <div class="tab-pane fade show active" id="descricao" role="tabpanel" aria-labelledby="descricao-tab">
                  <div class="col-md-12">
                    <div class="form-outline">
                      <label for="descricaoId" class="green-label">Descrição:</label>
                      <textarea rows="4" class="text-area-modal modal-input textarea-modal" v-model="atributo.descricao"></textarea>
                    </div>
                  </div>
                </div>
                <!-- Aba Domínio -->
                <div class="tab-pane fade" id="dominio" role="tabpanel" aria-labelledby="dominio-tab">
                  <div class="col-md-12">
                    <div class="form-outline">
                      <label for="dominioId" class="green-label">Domínio:</label>
                      <textarea rows="4" class="text-area-modal modal-input textarea-modal" v-model="atributo.dominio"></textarea>
                    </div>
                  </div>
                </div>
                <!-- Aba Observação -->
                <div class="tab-pane fade" id="observacao" role="tabpanel" aria-labelledby="observacao-tab">
                  <div class="col-md-12">
                    <div class="form-outline">
                      <label for="observacaoId" class="green-label">Observação:</label>
                      <textarea rows="4" class="text-area-modal modal-input textarea-modal" v-model="atributo.observacao"></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>
  
          </div>
    
          <div class="mt-5" role="group" aria-label="Basic example">
            <div class="row m-1">
              <div class="col-5">
                <button @click="closeModal" type="button" id="vendas" class="footer-button btn btn-primary" style="width: 105% !important;" data-mdb-ripple-init>CANCELAR</button>
              </div>
              <div class="col-1">
              </div>
              <div class="col-3">
                <button @click="editarNovoParametro(atributo)" type="button" id="gestao-carteira" style="width: 205% !important;color:white !important" class="footer-button btn btn-primary active" data-mdb-ripple-init>SALVAR</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

     <!-- O Modal Adicionar Parametros -->
     <div v-if="showModalAddParametros" class="modal modal-add-parametros fade" id="myModal" tabindex="-1" aria-labelledby="exampleModalLabel" aria-hidden="true">
      <div class="modal-dialog modal-lg">
        <div class="modal-content">
          <div class="modal-header">
            <h5 class="modal-title" style="font-weight: 600;">Adicionar Parâmetros</h5>
            <button type="button" class="btn-close" data-mdb-dismiss="modal" @click="closeModal" aria-label="Close"></button>
          </div>
          <div class="modal-body">
            <!-- Campo and Tipo row -->
            <div class="row">
              <div class="col-md-6">
                <div class="form-outline">
                  <label for="objetoId" class="green-label">Campo:</label>
                  <select class="form-select select-modal modal-input" id="objetoId" :disabled="this.bloqueioCampo">
                    <option value="Selecione">Selecione</option>
                    <option value="E">Entrada</option>
                    <option value="H">Header</option>
                    <option value="G">Get</option>
                    <option value="F">Form</option>
                    <option value="S">Saída</option>
                    <option value="A">Alerta</option>
                    <option value="W">Erro</option>
                    <option value="B">Body</option>
                  </select>
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-outline">
                  <label for="tipoAutenticacaoSelectAdicionar" class="green-label">Tipo:</label>
                  <select class="form-select select-modal modal-input" @change="validarTipo('tipoAutenticacaoSelectAdicionar','modify')" id="tipoAutenticacaoSelectAdicionar">
                    <option value="Selecione">Selecione</option>
                    <option value="O">Objeto</option>
                    <option value="C">Campo</option>
                    <option value="A">Autenticação</option>
                  </select>
                </div>
              </div>
            </div>
    
            <!-- Nome and Obrigatório row -->
            <div class="row">
              <div class="col-md-6">
                <div class="form-outline">
                  <label for="nomeModalAdicionar" class="green-label">Nome:</label>
                  <input id="nomeModalAdicionar">
                </div>
              </div>
              <div class="col-md-6">
                <div class="form-outline">
                  <label for="formatoAdicionar" class="green-label">Formato:</label>
                  <select class="form-select select-modal modal-input" id="formatoAdicionar" :disabled="this.bloqueioFormato">
                    <option value="Selecione" selected>Selecione</option>
                    <option value="A">Alfanumérico</option>
                    <option value="N">Numérico</option>
                    <option value="V">Valor</option>
                    <option value="O">Objeto - Container/classe</option>
                  </select>
                </div>
              </div>
              

            </div>
    
            <!-- Formato and Lista row -->
            <div class="row">
              
              <div class="col-md-6">
                <div class="form-outline">
                  <label for="obrigatorioId" class="green-label">Obrigatório:</label>
                  <select class="form-select select-modal modal-input" id="obrigatorioId">
                    <option value="">Selecione</option>
                    <option value="S">Sim</option>
                    <option value="N">Não</option>
                  </select>
                </div>
              </div>
              
              <div class="col-md-6">
                <div class="form-outline">
                  <label for="listaId" class="green-label">Lista:</label>
                  <select class="form-select select-modal modal-input" id="listaId">
                    <option value="">Selecione</option>
                    <option value="S">Sim</option>
                    <option value="N">Não</option>
                  </select>
                </div>
              </div>
            </div>

            <div class="mt-1 col-12">
              <!-- Nav Tabs com MDB Modal -->
              <ul class="nav nav-tabs" id="myTab" role="tablist">
                <li class="nav-item col-4" role="presentation">
                  <a class="nav-link active" id="descricao-tab-adicionar" data-mdb-toggle="tab" href="#descricaoAdicionar" role="tab" aria-controls="descricaoAdicionar" aria-selected="true">Descrição</a>
                </li>
                <li class="nav-item col-4" role="presentation">
                  <a class="nav-link" id="dominio-tab-adicionar" data-mdb-toggle="tab" href="#dominioAdicionar" role="tab" aria-controls="dominioAdicionar" aria-selected="false">Domínio</a>
                </li>
                <li class="nav-item col-4" role="presentation">
                  <a class="nav-link" id="observacao-tab-adicionar" data-mdb-toggle="tab" href="#observacaoAdicionar" role="tab" aria-controls="observacaoAdicionar" aria-selected="false">Observação</a>
                </li>
              </ul>
  
              <!-- Tab content -->
              <div class="tab-content mt-5 mb-5" id="myTabContent">
                <!-- Aba Descrição (aberta por padrão) -->
                <div class="tab-pane fade show active" id="descricaoAdicionar" role="tabpanel" aria-labelledby="descricao-tab-adicionar">
                  <div class="col-md-12">
                    <div class="form-outline">
                      <label for="descricaoModalAdicionar" class="green-label">Descrição:</label>
                      <textarea rows="4" class="text-area-modal modal-input textarea-modal" id="descricaoModalAdicionar"></textarea>
                    </div>
                  </div>
                </div>
                <!-- Aba Domínio -->
                <div class="tab-pane fade" id="dominioAdicionar" role="tabpanel" aria-labelledby="dominio-tab-adicionar">
                  <div class="col-md-12">
                    <div class="form-outline">
                      <label for="dominioId" class="green-label">Domínio:</label>
                      <textarea rows="4" class="text-area-modal modal-input textarea-modal" id="dominioModalAdicionar"></textarea>
                    </div>
                  </div>
                </div>
                <!-- Aba Observação -->
                <div class="tab-pane fade" id="observacaoAdicionar" role="tabpanel" aria-labelledby="observacao-tab-adicionar">
                  <div class="col-md-12">
                    <div class="form-outline">
                      <label for="observacaoId" class="green-label">Observação:</label>
                      <textarea rows="4" class="text-area-modal modal-input textarea-modal" id="observacaoModalAdicionar"></textarea>
                    </div>
                  </div>
                </div>
              </div>
            </div>

          </div>
    
          <!-- Footer buttons -->
          <div class="mt-5" role="group" aria-label="Basic example">
            <div class="row m-1">
              <div class="col-5">
                <button @click="closeModal" type="button" id="vendas" class="footer-button btn btn-primary" style="width: 105% !important;" data-mdb-ripple-init>CANCELAR</button>
              </div>
              <div class="col-1"></div>
              <div class="col-3">
                <button @click="salvarNovoParametro()" type="button" id="gestao-carteira" style="width: 205% !important; color:white !important;" class="footer-button btn btn-primary active" data-mdb-ripple-init>SALVAR</button>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
    
  </div>
</template>

<script>
import * as alertUtils from '@/utils/alert';
import * as loaderUtils from '@/utils/loader'
import $ from 'jquery'; // Importando jQuery 
import 'mdb-ui-kit'; // Importando o JavaScript do MDB
import * as ajaxUtils from '@/utils/ajax';
import * as validadorUtils from '@/utils/validador';

export default {
  name: "AtributesTabs",
  data() {
    return {
      clone: false,
      showModal: false,
      showModalAddParametros: false,
      showModalEditParametros: false,
      bloqueioFormato: false,
      bloqueioCampo: false,
      bloqueioTipo: false,
      bloqueioNome: false,
      bloqueioLista: false,
      statusAtributoPrincipal: true,
      statusAtributoSecundario: false,
      selectedListasServicos: "",
      selectedListasServicosAtributos: "",
      requestType: "",
      listaDadosServicos: [],
      listaDadosServicoCampos: [],
      listaDadosServicoAtributos: [],
      listaDadosServicoAtributosHierarquia: [],
      listaSecundariaAtributosHierarquia: [],
      listaAtributosHierarquiaPercorrido: [],
      atualDataEditParametros: [],
      listaAtributoPercorrido: [],
      atributosPercorridos: [],
      atributo: {
        tipo: "",
        nome: "",
        obrigatorio: "",
        formato: "",
        lista: "",
        descricao: "",
        observacao: "",
        idServicoApi: "",
        indexPai: "",
        disabledTipo: false,
        },
      servicoApi: {
        menu: "",
        introducao: "",
        url: "",
        metodo: "",
        requestType: "",
        idCatalogoApi: "",
        codigoMenuPai: ""
      },
      codigoMenuPai: "",
      tempTipo: "",
      tempNome: "",
      fluxoTela: [],
    };
  },
  props: {
    titulo: {
      type: String,
      required: false
    },
    descricao: {
      type: String,
      required: false
    },
    codigo: {
      type: String,
      required: true
    },
    codigoMenu: {
      type: String,
      required: false
    },
    subMenu: {
      type: Boolean,
      required: false
    },
    tipo: {
      type: String,
      required: false
    },
    menu: {
      type: String,
      required: false
    },
    entrada: {
      type: String,
      required: false
    },
    ordem: {
      type: String,
      required: false
    },
    listaDadosAtributosHierarquia: {
      type: Array,
      required: false
    }
  },
  computed: {
    atributosFiltrados() {
      const item = this.listaDadosServicoAtributosHierarquia.find(item => item.id === this.codigo);
      return item ? item.atributos : [];
    }
  },
  methods: {
    async toggleCollapse(event) {
      // Fecha todos os collapses
      const allCollapses = document.querySelectorAll('.collapse');
      allCollapses.forEach(function(collapse) {
        if (collapse !== document.querySelector(event.target.getAttribute('data-target'))) {
          $(collapse).collapse('hide');
        }
      });

      // Abre o collapse clicado
      const targetCollapse = document.querySelector(event.target.getAttribute('data-target'));
      $(targetCollapse).collapse('toggle');
    },
    async mudarTipo(status, metodo, tipoAlteracao) {
      const formato = tipoAlteracao === 1 ? 'formatoAdicionar': 'formatoEditar';

      if(metodo === 'modify' && status === true){
        this.bloqueioFormato = true;

        setTimeout(function() {
          $(`#${formato}`).val('O');
        }, 40);
      }

      if(metodo === 'modify' && status === false) {
        this.bloqueioFormato = false;

        setTimeout(function() {
          $(`#${formato}`).val('Selecione');
        }, 40);
      }
  
      if(metodo === 'open' && status === true){
        this.bloqueioFormato = true;
        setTimeout(function() {
          $(`#${formato}`).val('O');
        }, 40);
      }

      if(metodo === 'open' && status === false) this.bloqueioFormato = false;
    },
    async validarTipo(selectName, metodo) {
      const tipo = $(`#${selectName}`).val();

      const tipoAlteracao = selectName.includes("Adicionar") ? 1: 0;

      tipo === 'O' ? this.mudarTipo(true, metodo, tipoAlteracao): this.mudarTipo(false, metodo, tipoAlteracao);
    }, 


    async confirmacaoExclusaoAtributo(idServicoApi, index, nomeAtributo) {
      loaderUtils.addLoarder();

      alertUtils.alertConfirmacaoTop(`Deseja excluir o atributo ${nomeAtributo}?`).then(
        (result) => {
          if (result) {
            this.removerAtributo(idServicoApi, index);
          } else {
            loaderUtils.removeLoader();
          }
        }
      );
    },

    async removerAtributo(idServicoApi, index) {
      const urlApi = `/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/excluir-atributo/${idServicoApi}/${index}`;

      const requestAjax = await ajaxUtils.getOK(
        urlApi,
        '',
        '',
        ''
      );

      if(requestAjax){
        alertUtils.alertSuccess("Atributo removido com sucesso!");

        // Comunica Todos componentes referente a atualização (refresh)
        this.$emit('onAction', this.atributosPercorridos);
      } else {
        alertUtils.alertError("Erro ao excluir o Atributo!");
      }

      return requestAjax;
    },
    async editarNovoParametro() {
      try {
        this.atributo.tipo = this.tempTipo;
        this.atributo.nome = this.tempNome;

        // ID do serviço e índice do pai
        const idServicoApi = this.atributo.idServicoApi;
        const indexPai = this.atributo.ordem;
        const formato = $("#formatoEditar").val()
        const payload = {
          entrada: this.atributo.entrada,
          tipo: this.atributo.tipo,
          nome: this.atributo.nome,
          obrigatorio: this.atributo.obrigatorio,
          formato: formato,
          lista: this.atributo.lista,
          descricao: this.atributo.descricao,
          dominio: this.atributo.dominio,
          observacao: this.atributo.observacao
        };

        const url = `/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/alterar-atributo/${idServicoApi}/${indexPai}`;

        const editarParametro = await ajaxUtils.postOK(
          url,
          JSON.stringify(payload),
          'Parâmetro salvo com sucesso!',
          ''
        );

        if(editarParametro === true){
          this.closeModal();

          // Comunica Todos componentes referente a atualização (refresh)
          this.$emit('onAction', this.atributosPercorridos);
        }
      } catch (error) {
        console.error("Erro ao salvar o parâmetro:", error);
      }
    },
    async salvarNovoParametro() {
      // ID do serviço e índice do pai
      const idServicoApi = this.atributo.idServicoApi;
      const indexPai = this.atributo.indexPai ? this.atributo.indexPai: -1;
      const nome = $('#nomeModalAdicionar').val();
      const descricao = $('#descricaoModalAdicionar').val();
      const dominio = $('#dominioModalAdicionar').val();
      const observacao = $('#observacaoModalAdicionar').val();
      const tipo = $('#tipoAutenticacaoSelectAdicionar').val();
      const lista = $('#listaId').val();
      const obrigatorio = $('#obrigatorioId').val();
      const formato = $('#formatoAdicionar').val();

      let entrada = $('#objetoId').val();

      switch (entrada) {
        case "Header":
          entrada = "H"
        break;
        case "Entrada":
          entrada = "E"
        break;
        case "Get":
          entrada = "G"
        break;
        case "Form":
          entrada = "F"
        break;
        case "Saida":
          entrada = "S"
        break;
        case "Alerta":
          entrada = "A"
        break;
        case "Erro":
          entrada = "W"
        break;
        case "Body":
          entrada = "B"
        break;
      }

      const payload = {

        entrada: entrada,
        tipo: tipo === 'Selecione' ? '' : tipo,
        nome: nome,
        obrigatorio: obrigatorio,
        formato: formato === 'Selecione' ? '' : formato,
        lista: lista,
        descricao: descricao,
        dominio: dominio,
        observacao: observacao
      };

      const camposObrigatorios = validadorUtils.obterCamposObrigatoriosPadraoParametro();

      const erro = validadorUtils.validarCamposObrigatorios(payload, camposObrigatorios);

      if (erro) {
        return;
      }

      const requestAjax = await ajaxUtils.postOK(
        `/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/incluir-atributo/${idServicoApi}/${indexPai}`, 
        JSON.stringify(payload),
        '',
        ''
      );

      if(requestAjax){
        this.closeModal();

        alertUtils.alertSuccess("Parâmetro salvo com sucesso!");

        // Comunica Todos componentes referente a atualização (refresh)
        this.$emit('onAction', this.atributosPercorridos);
      } else {
        alertUtils.alertError("Erro ao salvar Parâmetro!");
      }

      return requestAjax;
    },
    async openModalAddParametros(tipo, idServicoApi, indexPai) {
      this.requestType = tipo ? tipo: "";

      tipo ? this.bloqueioCampo = true: this.bloqueioCampo = false;

      this.atributo.idServicoApi = idServicoApi || "";
      this.atributo.indexPai = indexPai !== null ? indexPai : "";
      this.atributo.disabledTipo = tipo !== "";
      this.showModalAddParametros = true;
      
      try {
        setTimeout(async () => {
          const modalElement = document.querySelector('.modal-add-parametros');
          const modalInstance = await new mdb.Modal(modalElement);

          // Antes de abrir o modal
          document.querySelectorAll('.modal-backdrop').forEach(el => el.remove());

          await modalInstance.show();

          this.resetForm();

          $("#objetoId").val(String(tipo));
        }, 200); // 200 milissegundos = 0.2 segundos
      } catch (error) {
        console.log(error)
      }
    },
    async openModalEditarParametros(tipo, idServicoApi, modalData) {
      this.requestType = tipo ? tipo: "";

      tipo ? this.bloqueioCampo = true: this.bloqueioCampo = false;

      if(this.clone === false){
        this.bloqueioTipo = true;
        this.bloqueioLista = true;
        this.bloqueioFormato = true;
        this.bloqueioNome = true;
      }

      this.showModalEditParametros = true;
      this.atributo = modalData;
      this.atributo.idServicoApi = idServicoApi;
      this.atualDataEditParametros = modalData;

      this.tempTipo = this.atributo.tipo;
      this.tempNome = this.atributo.nome;

      try {
        setTimeout(async () => {
          const modalElement = document.querySelector('.modal-edit-parametros');
          const modalInstance = await new mdb.Modal(modalElement);

          await modalInstance.show();

          $("#formatoEditar").val(this.atributo.formato);

          this.validarTipo('tipoAutenticacaoSelect', 'open');
        }, 200); // 200 milissegundos = 0.2 segundos
      } catch (error) {
        console.log(error);
      }
    },
    async excluirAgrupamento(idServicoApi, index) {
      this.removerAtributo(idServicoApi, index)
      
    },
    async closeModal() {
      this.showModal = false;

      $('.modal').hide();
      $('.modal-backdrop').hide();
      $('body').css('overflow', 'auto'); // Ativa a barra de rolagem

      this.$emit('onActionUpdate', "");
    },
    async resetForm() {
      // Resetando os campos <select>
      $('#tipoAutenticacao').val('Selecione');
      // Resetando os campos <select>
      $('#tipoAutenticacaoSelect').val('Selecione');
      $('#tipoAutenticacaoSelectAdicionar').val('Selecione');
      // Resetando os campos <select>
      $('#formato').val('Selecione');
      $('#formatoEditar').val('Selecione');

      // Resetando os campos de <input> e <textarea>
      $('#descricaoModalAdicionar').val('');
      $('#dominioModalAdicionar').val('');
      $('#observacaoModalAdicionar').val('');

      $('#nomeModalAdicionar').val('');

      $('#obrigatorioId').val('');

      $('#formato').val('');

      $('#listaId').val('');

      $('#tipoAutenticacaoSelect').val('');
    },
    async salvarFluxo(codigo, tipoFluxo) {
      if (!this.fluxoTela) {
        this.fluxoTela = {};
      }

      if(tipoFluxo === 'section') {
        this.fluxoTela.sectionAcessado = codigo;
      }

      if (tipoFluxo === 'service') {
        this.fluxoTela.serviceAcessado = codigo;
      }

      if (tipoFluxo === 'atributes') {
        this.fluxoTela.atributoAcessado = codigo;

        if (!this.atributosPercorridos.includes(codigo)) {
          this.atributosPercorridos.push(codigo);
        }
      }
      
      if (tipoFluxo != 'service' && tipoFluxo != 'section' && tipoFluxo != 'atributes') {
        this.fluxoTela.menuAcessado = codigo;
      }      
    },
    async alterarIcone(iconId, tipoFluxo, codigo) {
      if(iconId === 'atributoPrincipal') this.atributosPercorridos = [];
      
      this.salvarFluxo(codigo, tipoFluxo);
      
      if(iconId.length >= 1) {
        const iconeSetadoDown = $('#'+iconId).hasClass('fa-angle-down');
        const iconeSetadoRight = $('#'+iconId).hasClass('fa-angle-right');

        if(iconeSetadoRight === true) {
          $('#'+iconId).removeClass('fa-angle-right');

          $('#'+iconId).addClass('fa-angle-down');
        } else if(iconeSetadoDown === true) {
          $('#'+iconId).removeClass('fa-angle-down');

          $('#'+iconId).addClass('fa-angle-right');
        }
      }
    },
    async atualizarAtributoPercorrido(ordem, nome, atributo) { 
      if(!this.listaAtributoPercorrido){
        this.listaAtributoPercorrido = [{"ordem":String(`${ordem}`),"nome":String(nome)}];
      } else {
        let atributoExiste = false;

        this.listaAtributoPercorrido.forEach(atributo => {
          if(atributo.nome === nome) atributoExiste = true;
        });

        if(!atributoExiste && atributo.length >= 1) this.listaAtributoPercorrido.push({"ordem":String(`${ordem}`),"nome":String(nome)});
      }
    },
    async atualizarHierarquia(novaHierarquia, navegacao, ordem) {
      this.statusAtributoPrincipal = false;
      this.statusAtributoSecundario = true;

      if (ordem && novaHierarquia && novaHierarquia[0]) novaHierarquia ? novaHierarquia[0].ordemFluxo = ordem :  '';

      if (navegacao && ordem.length >= 1) {
        // Busca dentro de cada array salvo em listaAtributosHierarquiaPercorrido
        const encontrado = this.listaAtributosHierarquiaPercorrido.find(lista =>
          lista.some(item => item.ordemFluxo === ordem)
        );

        if (encontrado) {
          this.listaSecundariaAtributosHierarquia = encontrado;
        } else {
          console.warn(`Nenhuma hierarquia encontrada com descricao: "${ordem}"`);
        }
      } else {
        if (novaHierarquia.length >= 1) {
          this.listaSecundariaAtributosHierarquia = novaHierarquia;

          const jaExiste = this.listaAtributosHierarquiaPercorrido.some(item =>
            JSON.stringify(item) === JSON.stringify(novaHierarquia)
          );

          if (!jaExiste) {
            this.listaAtributosHierarquiaPercorrido.push(novaHierarquia);
          }
        }
      }
    },
    async alterarAtributoPercorrido(ordem) {
      const index = this.listaAtributoPercorrido.findIndex(atributo => atributo.ordem === ordem);

      if (index !== -1) {
        // Mantém apenas os itens até o índice da ordem
        this.listaAtributoPercorrido = this.listaAtributoPercorrido.slice(0, index + 1);
      }
    },
    async zerarAtributoPercorrido() {
      this.statusAtributoPrincipal = true;
      this.statusAtributoSecundario = false;

      this.listaAtributoPercorrido = [];
      this.atributosPercorridos = [];
    },
    async buscarServico(idServico) {
      loaderUtils.addLoarder();

      let urlApi;
      let method;
      let requestOptions;

      urlApi = '/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/consultar-servico/'+ idServico;
      method = 'GET';

      requestOptions = {
        method: method
      };

      try {
        fetch(urlApi, requestOptions)
          .then(async (response) => {
            if (response.ok) {
              return response.json();
            } else {
              throw new Error('Fechar');
            }
          })
          .then(async (data) => {
            if (Array.isArray(this.listaDadosServicoCampos) && this.listaDadosServicoCampos.length >= 1) {
              this.listaDadosServicoCampos.forEach(item => {
                // Verifique se o item já existe no array (baseado em alguma propriedade, por exemplo 'idCatalogoApi')
                const itemExiste = this.listaDadosServicoCampos.some(item => item.idServicoApi === data.idServicoApi);

                this.listaDadosServicos.forEach(dadoServico => {
                    // String original
                    const codigoString = dadoServico.codigo;

                    // Usando uma expressão regular para extrair os números do código
                    const numbers = codigoString.match(/\d+/); // Isso irá extrair todos os números da string

                    const codigo = numbers[0];
 
                  });

                // Se o item não existir, adicione-o ao array
                if (!itemExiste) {

                  this.listaDadosServicoCampos.push(data);

                  this.listaDadosServicos.forEach(dadoServico => {
                    // String original
                    const codigoString = dadoServico.codigo;

                    // Usando uma expressão regular para extrair os números do código
                    const numbers = codigoString.match(/\d+/); // Isso irá extrair todos os números da string

                    const codigo = numbers[0];
 
                  });

                  // Criando o objeto com os dados e o identificador
                  const novoItem = {
                    id: idServico,
                    atributos: data.atributos
                  };

                  this.listaDadosServicoAtributos.push(data.atributos);
                  this.listaDadosServicoAtributosHierarquia.push(novoItem);
                }
              });
            } else {
              this.listaDadosServicoCampos.push(data);

              this.listaDadosServicos.forEach(dadoServico => {
                // String original
                const codigoString = dadoServico.codigo;

                // Usando uma expressão regular para extrair os números do código
                const numbers = codigoString.match(/\d+/); // Isso irá extrair todos os números da string

                const codigo = numbers[0];
 
              });

              // Criando o objeto com os dados e o identificador
              const novoItem = {
                id: idServico,
                atributos: data.atributos
              };

              this.listaDadosServicoAtributos.push(data.atributos);
              this.listaDadosServicoAtributosHierarquia.push(novoItem);
            }

            loaderUtils.removeLoader();

            return data;
          })
          .catch((error) => {
            console.log(error);
          }).finally(() => 'loaderUtils.removeLoader()');
        
      } catch (error) {
        console.error('Erro ao realizar busca:', error);
        alertUtils.alertError('Erro ao realizar busca:'+ error);
      }
    },
    async pesquisarServicoMenu(idCatalogo, codigoMenu) {
      loaderUtils.addLoarder();

      if(idCatalogo != undefined){
        let urlApi;
        let method;
        let requestOptions;
      
        urlApi = '/massificados/corporativo/gerenciador-parceiros/rest/manutencao-catalogo-servico/servicos/'+ idCatalogo +'/'+ codigoMenu;
        method = 'GET';

        requestOptions = {
          method: method
        };

        try {
          fetch(urlApi, requestOptions)
            .then(async (response) => {
              if (response.ok) {
                return response.json();
              } else {
                throw new Error('Fechar');
              }
            })
            .then(async (data) => {
              this.listaDadosServicos = data;

              this.buscarServico(this.codigo);

              loaderUtils.removeLoader();

              return data;
            })
            .catch((error) => {
              console.log(error);
            }).finally(() => 'loaderUtils.removeLoader()');
          
        } catch (error) {
          console.error('Erro ao realizar busca:', error);
          alertUtils.alertError('Erro ao realizar busca:'+ error);
        }
      }
    },
   
  },
  mounted() {
    document.body.addEventListener('click', this.setandoVisibilidade);

    // Acesse o hash da URL
    const hash = window.location.hash;

    // Remova a primeira barra ("/") e separe a string com base nas barras
    const idCatalogo = hash.split('/').pop();

    this.pesquisarServicoMenu(idCatalogo, this.codigoMenu);

    // this.buscarServico(this.codigo);

    this.idCatalogo = this.$route.params.idCatalogo;
    if (this.idCatalogo.indexOf("-clone") != -1) {
      this.clone = true;
    }


  },
}
</script>

<style scoped>
  @import '/massificados/corporativo/gerenciador-parceiros-ui/portal-sistemas/css/tabs/style.css';
</style>
